import React from 'react';
import Pageheader from '../utils/headerHelment';
import SecurityGovernance from '../components/SecurityGovernance';

const SecurityGovernancePage = () => {
    return (
        <>
            <Pageheader title="LENS - Security Governance" />
            <SecurityGovernance />
        </>
    );
};

export default SecurityGovernancePage;
